module.exports = __webpack_public_path__ + "img/myhy@2x.df9f5a1d.png";